/**
 * URL Parameter Encryption / Encoding Utility for Patient EMR URLs
 */

// Encode / Encrypt numeric or string ID to URL-safe token
export const encodePatientId = (id) => {
  if (id === undefined || id === null || id === '') return '';
  try {
    const raw = String(id);
    // URL-safe Base64 encoding
    const encoded = btoa(raw)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
    return encoded;
  } catch (e) {
    return String(id);
  }
};

// Decode / Decrypt URL parameter back to original ID
export const decodePatientId = (token) => {
  if (!token) return '';
  const strToken = String(token).trim();

  // If already a plain number, return directly
  if (/^\d+$/.test(strToken)) {
    return strToken;
  }

  try {
    // Restore Base64 padding and characters
    let base64 = strToken.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    const decoded = atob(base64);
    if (decoded && decoded.length > 0) {
      return decoded;
    }
  } catch (e) {
    // If decoding fails, return raw token
  }
  return strToken;
};

// Build encrypted patient link
export const getPatientUrl = (id, tab = null) => {
  const encId = encodePatientId(id);
  let url = `/patient?_p=${encId}`;
  if (tab) {
    url += `&_t=${encodeURIComponent(tab)}`;
  }
  return url;
};
